import Vue from 'vue';
import Vuex from 'vuex';
import indents from '@/modules/indents/store';
import mdmV2 from '@/modules/mdm/store';
import app from './modules/app';
import payment from './modules/payment';
import paymentsV2 from './modules/payments-v2';
import profile from './modules/profile';
import user from './modules/user';
import wallet from './modules/wallet';
import walletV2 from './modules/wallet-v2';
import tracking from './modules/tracking';
import report from './modules/report';
import order from './modules/order';
import planning from './modules/planning';
import settings from './modules/settings';
import podAiValidation from './modules/podAiValidation';

Vue.use(Vuex);

function enableNamespacedModule() {
  const modules = {
    indents,
    app,
    payment,
    paymentsV2,
    profile,
    wallet,
    walletV2,
    user,
    tracking,
    report,
    mdmV2,
    order,
    planning,
    settings,
    podAiValidation,
  }; // add new modules here;
  const keys = Object.keys(modules);
  keys.forEach((module) => {
    modules[module].namespaced = true;
  });
  return modules;
}

const modules = enableNamespacedModule();
export default new Vuex.Store({
  modules,
});
